import { render, staticRenderFns } from "./videoPlaceholder.vue?vue&type=template&id=f65f39f6&"
import script from "./videoPlaceholder.vue?vue&type=script&lang=js&"
export * from "./videoPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./videoPlaceholder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports